'use client'
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { useState, useEffect } from "react";

/**
 * @typedef {import("@prismicio/client").Content.FeaturedArticleTeaserSlice} FeaturedArticleTeaserSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FeaturedArticleTeaserSlice>} FeaturedArticleTeaserProps
 * @type {import("react").FC<FeaturedArticleTeaserProps>}
 */


const FeaturedArticleTeaser = ({ slice, index, context }) => {
  const { title, publish_date, img } = slice.primary;
  const { tags } = context;

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const imageUrl = isDesktop
    ? img?.url
    : img?.url;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="text-dark-green mb-10 lg:mb-36"
    >
      <div className="framing ">
        <Breadcrumbs context={context} index={index} textcolor={"text-dark-green"}/>
      </div>
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-0">
        {isFilled.image(img) && (
          <div className="w-full lg:w-[45%] h-[200px] md:h-[350px] lg:h-auto bg-no-repeat bg-center bg-cover lg:order-2"
            style={{ backgroundImage: `url(${imageUrl})` }} >
            <img src="/masque-img.svg" alt="décoration blanche" className="hidden lg:block h-[110%] -ml-8 -mt-4 w-auto relative z-0" />
          </div>
        )}
        <div className="md:pt-14 lg:pb-26 flex flex-col gap-6 lg:w-[55%] px-5 md:px-10 lg:pr-0 lg:pl-23 lg:order-1 relative z-[10]">
          <div className="flex flex-col gap-2 lg:gap-0">
            {isFilled.date(publish_date) && (
              <span className="text-date">
                {new Date(publish_date).toLocaleDateString("fr-FR")}
              </span>
            )}
            {isFilled.richText(title) && (
              <PrismicRichText
                field={title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="h1-blog">{children}</h1>
                  ),
                }}
              />
            )}
          </div>

          <div>
            {tags?.length > 0 && (
              <div className="flex flex-wrap gap-4">
                {tags.map((tag) => (
                  <span key={tag} className="text-tags tag-green text-white">
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>


        </div>
      </div>
    </section>
  );
};

export default FeaturedArticleTeaser;
